module.exports = __webpack_public_path__ + "img/mainImg.67fefa96.jpg";